// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__1ZqCA","link-read-more":"Accordion_link-read-more__25F5H","description":"Accordion_description__1Gnjc"};